import dayjs, { Dayjs } from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { newYearHolidays } from '@lifedot/constants/holidays'

dayjs.extend(isBetween)

export const isNewYearsHoliday = (day: Dayjs) => {
  return day.isBetween(newYearHolidays.start, newYearHolidays.end, 'day', '[]')
}
